import { cn } from "@/lib/utils";
import type { KrajinaKod } from "@/lib/constants";
import Image from "next/image";

interface FlagProps {
  kod: KrajinaKod | string;
  className?: string;
  size?: number;
}

const FLAG_CODES: Record<string, string> = {
  SVK: "sk",
  FIN: "fi",
  SWE: "se",
  ITA: "it",
  CAN: "ca",
  CZE: "cz",
  SUI: "ch",
  FRA: "fr",
  US: "us",
  USA: "usa",
  GER: "de",
  LAT: "lv",
  DEN: "dk",
  NOR: "no",
  RU: "ru",
  AUT: "at",
  KZ: "kz",
  BLR: "by",
  SLO: "si",
  HUN: "hu",
  GBR: "gb",
  POL: "pl",
  JPN: "jp",
};

export function Flag({ kod, className, size = 24 }: FlagProps) {
  const width = size * 1.5;

  if (!kod) {
    return (
      <div
        className={cn("bg-muted rounded shadow-xs", className)}
        style={{ width: `${width}px`, height: `${size}px` }}
      />
    );
  }

  if (kod.toUpperCase() === "TBD") {
    return (
      <Image
        src="/assets/flags/otaznik.svg"
        alt="TBD flag"
        width={width}
        height={size}
        style={{ width: `${width}px`, height: `${size}px` }}
        className={cn("object-contain", className)}
        unoptimized
        priority
      />
    );
  }

  const flagCode = FLAG_CODES[kod.toUpperCase()];

  if (!flagCode) {
    return (
      <div
        className={cn("bg-muted rounded shadow-xs", className)}
        style={{ width: `${width}px`, height: `${size}px` }}
      />
    );
  }

  return (
    <Image
      src={`/assets/flags/${flagCode}.svg`}
      alt={`${kod} flag`}
      width={width}
      height={size}
      style={{ width: `${width}px`, height: `${size}px` }}
      className={cn("object-contain", className)}
      unoptimized
      priority
    />
  );
}

export function FlagWithName({
  kod,
  nazov,
  size = 24,
  className,
}: FlagProps & { nazov: string }) {
  return (
    <div className={cn("flex items-center gap-2 sm:gap-3", className)}>
      <Flag kod={kod} size={size} />
      <span className="font-medium">{nazov}</span>
    </div>
  );
}
